<template>
  <div
    v-if="showBanner"
    data-testid="banner-trial-period"
    class="com_notification-box com_notification-box--buttonbar-right"
    :class="{
      'com_notification-box--info': !didTrialPeriodEnd,
      'com_notification-box--alert': didTrialPeriodEnd,
    }"
  >
    <div
      class="com_notification-box__content"
    >
      <h5
        class="com_notification-box__title"
      >
        <span
          v-if="didTrialPeriodEnd"
          data-testid="banner-trial-period-ended"
        >
          {{ $t('feature.account.trial_period_banner.trial_period_ended', { date: daysToTrialEnd }) }}
        </span>

        <span
          v-if="!didTrialPeriodEnd"
          data-testid="banner-trial-period-ending"
        >
          {{ $t('feature.account.trial_period_banner.trial_period_ends', { date: daysToTrialEnd }) }}
        </span>
      </h5>

      <p
        class="com_notification-box__text"
      >
        {{ $t('feature.account.trial_period_banner.continue_working_if_plan_selected') }}
      </p>
    </div>

    <PfButtonBar
      class="com_notification-box__action"
    >
      <router-link
        :to="{ name: 'account' }"
        class="com_button-bar__button obj_button"
        @click="onClickChoosePlanLink"
      >
        <span
          class="label"
        >
          {{ $t('feature.account.trial_period_banner.choose_plan') }}
        </span>
      </router-link>

      <a
        class="com_button-bar__link"
        :href="$utm($t('data.pf_links.personal_support'), 'trial-banner-contact-link')"
        target="_blank"
        @click="onClickHelpLink"
      >
        {{ $t('feature.account.trial_period_banner.extend_test_phase') }}
      </a>
    </PfButtonBar>
  </div>
</template>

<script>
import PfButtonBar from '@/components/PfButtonBar.vue'
import { useShowBannerTrialPeriod } from '@/composables/trial-period'

export default {
  name: 'BannerTrialPeriod',

  components: {
    PfButtonBar,
  },

  setup () {
    const { showBanner, didTrialPeriodEnd, daysToTrialEnd } = useShowBannerTrialPeriod()

    return {
      showBanner,
      didTrialPeriodEnd,
      daysToTrialEnd,
    }
  },

  methods: {
    onClickHelpLink () {
      this.$ga.event({
        eventCategory: 'gotoWebsite',
        eventAction: 'gotoWebsite via trial-ends-link',
      })
    },

    onClickChoosePlanLink () {
      this.$ga.event({
        eventCategory: 'gotoPayment',
        eventAction: 'gotoPayment via trial-ends-button',
      })
    },
  },
}
</script>
